export default __webpack_public_path__ + "static/media/tirza2.21c21fba.jpg";